/**
 * Petition signatures list: More / Fewer Signatures toggle.
 * Moved out of snippets/cusa-petition-signatures.liquid (inline).
 */
const prepareToExpand = () => {
	const list = document.getElementById('petition-signatures-list');
	const expandButton = document.getElementById('petition-signatures-expand');
	if (!list || !expandButton) return;
	const itemsWhichHide = list.querySelectorAll('[hidden]'); // caching
	expandButton.onclick = () => {
		let expanded = 'true' === expandButton.getAttribute('aria-expanded');
		expanded = !expanded;
		itemsWhichHide.forEach((item) => item.toggleAttribute('hidden', !expanded));
		expandButton.setAttribute('aria-expanded', expanded.toString());
		expandButton.textContent = expanded ? 'Fewer Signatures' : 'More Signatures';
		list.scrollIntoView();
	};
};
document.addEventListener('DOMContentLoaded', prepareToExpand);
